/**
 * @fileoverview > handler for the "/engagement/:app_group_id/create_email_test" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCreateEmailTestCacheKeys } from "./constants";
import type { PostEngagementAppGroupIdCreateEmailTestProps, EngagementCreateEmailTestResult } from "./types";

export const postEngagementCreateEmailTest = reactQueryMutationAdapter(
  engagementAppGroupIdCreateEmailTestCacheKeys,
  ({
    appGroupId,
    message,
  }: PostEngagementAppGroupIdCreateEmailTestProps): Promise<EngagementCreateEmailTestResult> => {
    return fetch(`/engagement/${appGroupId}/create_email_test`, "POST", { message });
  }
);
